export default __webpack_public_path__ + "static/bwtransport-6-8c556f4c9578a7eb58b415f9d1210b3e.png";